import { crudRequest } from '@/services/api';
import { getToDay } from '@/utils/date';
import moment from 'moment';

const paramsForm = {
  dateRange: getToDay(),
}

export default {
  namespace: 'fileexport',
  state: {
    dateRange: [moment(paramsForm.dateRange[0]).add(-2, 'days'), paramsForm.dateRange[1]],
    fileName: '',
    dateFormat: 'YYYY-MM-DD HH:mm:ss',

    pageSize: 20,
    page: 1,
    total: 0,
    fileDataList:[]
  },

  effects: {
    *getFileList(_, { call, put, select }) {
      const { dateRange, fileName, dateFormat, pageSize, page } = yield select(({ fileexport }) => fileexport)
      // const logs = yield 
      // crudRequest('/api/route/fileExport/search')
      // if (logs?.code !== 1) return
      const data = yield crudRequest(
        '/api/route/getDownloadMessage',
        {
          pageSize, page,
          fileIndexVo: {
            startTime: dateRange[0].format(dateFormat),
            endTime: dateRange[1].format(dateFormat),
            fileName: fileName,
          }
        }
      )
      if (data?.code === 1) {
        const { rows, total } = data?.data
        yield put({
          type: 'updateState', payload: {
            fileDataList: rows || [],
            total: Number.parseInt(total || 0)
          }
        })
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}